import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import type EntryModel from 'garaje/models/entry';
import type VisitorDocumentModel from 'garaje/models/visitor-document';

interface RemoveVisitorDocumentConfirmationComponentSignature {
  Args: {
    /**
     * Action to close the modal
     */
    close: () => void;
    /**
     * task performed when confirming
     */
    onSubmit: (visitorDocument: VisitorDocumentModel, entry: EntryModel) => Promise<void>;
    entry: EntryModel;
    visitorDocument: VisitorDocumentModel;
  };
}

export default class RemoveVisitorDocumentConfirmationComponent extends Component<RemoveVisitorDocumentConfirmationComponentSignature> {
  onSubmitTask = dropTask(async (e: Event) => {
    const { visitorDocument, entry } = this.args;

    e.preventDefault();

    await this.args.onSubmit(visitorDocument, entry);

    this.args.close();
  });
}
